function SliderGallery(container){
	var _this = this;
	this.container = $(container);
	this.img = this.container.find('.slides img');
	this.li = this.container.find('.slides li');
	this.img.each(function(){

		var img = $(this),
			w = img.width(),
			h = img.height(),
			t = img.position().top,
			l = img.position().left,

			imgNew = img.clone().appendTo(img.parent()).css({position: 'absolute', left: l, top: t, width: 'auto', height: 'auto'}),

			wNew = imgNew.width(),
			hNew = imgNew.height(),

			tNew = t + (w - wNew) / 2,
			lNew = l + (h - hNew) / 2;

		img.css({visibilty: 'hidden'});
		imgNew.css({position: 'absolute', width: w, height: h, left: l, top: t});

		$(this).parent().bind({
			mouseover: function() {
				imgNew.stop().animate({width: wNew, height: hNew, left: lNew, top: tNew},{easing: 'easeOutCubic', queue: false, duration: 150});
			},
			mouseleave: function() {
				imgNew.stop().animate({width: w, height: h, left: l, top: t},{easing: 'easeOutCubic', queue: false, duration: 100});
			}
		});
	});
	$(this.container).flexslider({
		pauseOnHover: true,
		useCSS: false,
		animation: "slide",
		controlNav: false,
		directionNav: true,
		animationLoop: false,
		slideshow: false,
		itemWidth: 231,
		itemMargin: 5
	});
}

if (typeof define === "function" && define.amd) {
	define('Controls/SliderGallery',['flexslider'], function() {
		return SliderGallery;
	});
};
